import { FileText, FilePdf, FileImage, File as FileIcon } from '@phosphor-icons/react';
import { fmtSize, fmtDate } from './nasApi';

const iconFor = (ext) => {
  if (ext === '.pdf') return FilePdf;
  if (['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp'].includes(ext)) return FileImage;
  if (['.txt', '.md', '.csv', '.docx', '.xlsx', '.pptx'].includes(ext)) return FileText;
  return FileIcon;
};

// NAS file card — visually matches the Documents module but is functionally
// independent. No DMS number, folder, stamp, move, replace or trash actions.
export default function NasFileCard({ file, onOpen }) {
  const Icon = iconFor((file.ext || '').toLowerCase());
  return (
    <button type="button" onClick={() => onOpen(file)}
      data-testid={`nas-file-card-${file.node_id}`}
      className="text-left rounded-lg border border-zinc-200 bg-white p-3 hover:border-teal-300 hover:shadow-sm transition-[box-shadow,border-color] duration-200">
      <Icon size={26} weight="duotone" className="text-teal-700 mb-2" />
      <p className="text-sm font-medium text-zinc-900 truncate" title={file.name}>{file.name}</p>
      <p className="text-xs text-zinc-400 truncate" title={file.logical_path}>{file.logical_path || ''}</p>
      <p className="text-xs text-zinc-400 tabular-nums mt-1">{fmtSize(file.size)} · {fmtDate(file.modified)}</p>
    </button>
  );
}
